import React from 'react';
import { observer } from 'mobx-react-lite';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { globalTranslationKeys } from '../../../../enums';

const QuickButtonsSection = observer(({ t, limits, betAmount, handleChangeInputValue }) => {
  const { minBet, maxBet } = limits;
  return (
    <div className='monti-calc-buttons'>
      <div
        className={`monti-calc-button ${betAmount <= minBet ? 'disabled' : ''}`}
        title={t(globalTranslationKeys.Min)}
        onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.min)}
      >
        <div className='monti-calc-button-inside'>
          <span className='monti-calc-button-txt'>{t(globalTranslationKeys.Min)}</span>
        </div>
      </div>
      <div
        className='monti-calc-button'
        title='1/2'
        onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.divide)}
      >
        <div className='monti-calc-button-inside'>
          <span className='monti-calc-button-txt'>1/2</span>
        </div>
      </div>
      <div
        title='x2'
        className='monti-calc-button'
        onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.multiply, 2)}
      >
        <div className='monti-calc-button-inside'>
          <span className='monti-calc-button-txt'>x2</span>
        </div>
      </div>
      <div
        className={`monti-calc-button ${betAmount >= maxBet ? 'disabled' : ''}`}
        title={t(globalTranslationKeys.Max)}
        onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.max)}
      >
        <div className='monti-calc-button-inside'>
          <span className='monti-calc-button-txt'>{t(globalTranslationKeys.Max)}</span>
        </div>
      </div>
    </div>
  );
});

export default QuickButtonsSection;
